// 100vh mobile hack
var appHeight = () => {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

// Mutation observer function to detect loaded content
function waitForElement(querySelector, timeout){
  return new Promise((resolve, reject)=>{
    var timer = false;
    if(document.querySelectorAll(querySelector).length) return resolve();
    var observer = new MutationObserver(()=>{
      if(document.querySelectorAll(querySelector).length){
        observer.disconnect();
        if(timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true, 
      subtree: true
    });
    if(timeout) timer = setTimeout(()=>{
      observer.disconnect();
      reject();
    }, timeout);
  });
}

// Customize prices
function customizePrice(regularPrice, discountPercent){
  var priceValue = parseFloat(regularPrice.replace(/[^\d.,-]/g, "").replace(",", ".").replace(/\.(?=.*\.)/g, ""));
  var discount = Math.ceil((priceValue * discountPercent / 100) * 10) / 10;
  return (priceValue - discount).toFixed(2).replace('.', ',') + '€';
}

// Stop animations on resize
let resizeTimer;
window.addEventListener("resize", () => {
  document.body.classList.add("resizing");
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove("resizing");
  }, 400);
});

// Hide Instafeed if adBlocker
if( window.canRunAds === undefined ){
  document.getElementById('insta-feed-container').style.display = "none";
}

// Sticky header
var header = document.querySelector("#header");
var headroom = new Headroom(header, {
  offset: {
    up: 50,
    down: 0
  },
  tolerance : {
      up : 10,
      down : 5
  },
  // css classes to apply
  classes : {
    // when element is initialised
    initial : "loaded",
    // when scrolling up
    pinned : "pinned",
    // when scrolling down
    unpinned : "unpinned",
    // when above offset
    top : "top",
    // when below offset
    notTop : "nottop",
    // when at bottom of scroll area
    bottom : "bot",
    // when not at bottom of scroll area
    notBottom : "notbot",
    // when frozen method has been called
    frozen: "frozen"
  }
});
headroom.init();

// Menu toggle
var menuToggle = document.getElementById('menu-toggle');
menuToggle.addEventListener('change', function(e) {
  if (e.currentTarget.checked) {
    header.classList.add('expanded');
  } else {
    header.classList.remove('expanded');
  }
})
window.addEventListener('scroll', function() {
  if (menuToggle.checked) {
    menuToggle.checked = false;
    header.classList.remove('expanded');
  }
});

// Slidecart
var slideCart;
var slideCartTotal;
var slideCartItems;
var freeshipBar;
var menuCartBubble = document.querySelector('.cart-count-bubble');
var freeshipOption = false;
var freeshipUnlock = 99;
var subDiscount = 5;
var subDiscountMax = 20;
var slideCartOpened = false;
const slideCartObserver = new MutationObserver(() => {
  updateCart(slideCart);
});
const itemsObserver = new MutationObserver(() => {
  updateCart(slideCart);
});
var menuCart = document.querySelector('.menu-cart');
menuCart.addEventListener('click', function(e){
  if(!this.classList.contains('slidecarthq-loaded')){
    e.preventDefault();
  }
  if (menuToggle.checked) {
    menuToggle.checked = false;
    header.classList.remove('expanded');
  }
});
waitForElement('.slidecarthq', 20000).then(function(){
  slideCart = document.querySelector('.slidecarthq');
  menuCart.classList.add('slidecarthq-loaded');
  slideCartObserver.observe(slideCart, {subtree: false, childList: false, attributes: true});
  var slideCartHeader = slideCart.querySelector('.header');
  var cartIcon = menuCart.querySelector('.icon');
  slideCartHeader.querySelector('h2').appendChild(cartIcon.cloneNode(true));
  if(freeshipOption){
    slideCartHeader.classList.add('freeship-visible');
    freeshipBar = document.createElement('div');
    freeshipBar.classList.add('freeship');
    freeshipBar.innerHTML = '<p>Plus que <strong class="remaining">'+ freeshipUnlock +'</strong><strong>€</strong> pour bénéficier de la livraison gratuite</p><p>Vous bénéficiez de la <strong>livraison gratuite</strong>&#8239;!</p>';
    slideCartHeader.appendChild(freeshipBar);
  }
  document.querySelector('button[name="checkout"]').addEventListener('click', function(){
    this.parentNode.classList.add('is-loading');
  });
}).catch(()=>{
  // console.log('Cart not loaded');
});

function updateCart(el){
  if(slideCartOpened){
    itemsObserver.disconnect(); // Pause observer before updating content
  }
  var slideCartTotalValue = 0;
  slideCartItems = el.querySelectorAll('.item');
  if(slideCartItems.length > 0){
    // Update each item details
    slideCartItems.forEach(function(item){
      updateItem(item);
      slideCartTotalValue += parseFloat(item.querySelector('.offer-details .price').innerText.replace(',', '.').replace(',00', ''));
    });
    slideCart.querySelector('#slidecart-checkout-form').setAttribute('data-total', slideCartTotalValue.toFixed(2).replace('.', ',') + '€');
    // Synchronize cart icon bubbles
    menuCartBubble.setAttribute('data-itemscount', el.querySelector('.header .cart-count').innerHTML);
    menuCartBubble.querySelector('span:first-of-type').innerHTML = el.querySelector('.header .cart-count').innerHTML;
  } else{
    menuCartBubble.setAttribute('data-itemscount', '0');
    menuCartBubble.querySelector('span:first-of-type').innerHTML = '0';
  }
  if(freeshipOption){
    var freeshipRemaining = (freeshipUnlock - slideCartTotalValue).toFixed(2).replace('.', ',').replace(',00', '');
    var freeshipProgress = parseFloat(slideCartTotalValue * 100 / freeshipUnlock).toFixed(2);
    if (freeshipProgress >= 50){
      freeshipBar.classList.add('active');
    } else{
      freeshipBar.classList.remove('active');
    }
    if (freeshipProgress >= 100){
      freeshipProgress = 100;
    }
    freeshipBar.setAttribute('data-progress', freeshipProgress);
    freeshipBar.style.setProperty('--progress', freeshipProgress + '%');
    freeshipBar.querySelector('.remaining').innerHTML = freeshipRemaining;
  }
  itemsObserver.observe(el, { childList: true, subtree: true });
  slideCartOpened = true;
}
function updateItem(el){
  var defaultprice = el.querySelector('.main-bottom .price').innerHTML;
  el.setAttribute('data-count', el.querySelector('.quantity-selector input').value);
  if (el.querySelector('.offer-details') == null){
    var content = el.querySelector('.main-top-left');
    var offerDetails = document.createElement('div');
    offerDetails.classList.add('offer-details');
    offerDetails.innerHTML = '<span class="price"></span><span class="interval"></span>';
    content.appendChild(offerDetails);
  }
  var updatedPrice = el.querySelector('.offer-details .price');
  var updatedInterval = el.querySelector('.offer-details .interval');
  if(el.querySelectorAll('li[data-key=""]').length > 0){
    el.classList.remove('onetime');
    el.classList.add('subscription');
    if(el.querySelector('li[data-key=""] span').innerText.includes('coffret')){
      el.classList.add('coffret');
    }
    updatedPrice.innerHTML = defaultprice;
    updatedInterval.innerHTML = el.querySelector('li[data-key=""] span').innerText.replace(/\D/g,'');
  } else{
    el.classList.remove('subscription', 'coffret');
    el.classList.add('onetime');
    updatedPrice.innerHTML = defaultprice;
    updatedInterval.innerHTML = '';
  }
  if(el.querySelectorAll('[data-key="Mouture"]').length > 0){
    el.classList.add('is-coffee');
  } else{
    el.classList.remove('is-coffee');
  }
  var productTitle = el.querySelector('.title a');
  if (productTitle.innerText.includes('"')){
    el.querySelector('.title').classList.add('italic-title');
    productTitle.innerHTML = productTitle.innerHTML.slice(1, -1);
  }
}

// Abonnements scripts
var bodyIsAbonnements = document.body.classList.contains('nos-abonnements');
if(bodyIsAbonnements){
  var abosPrice = document.querySelectorAll('.abo-price strong');
  abosPrice.forEach(function(aboPrice, index){
    if (index == 0){
      aboPrice.innerHTML = customizePrice(aboPrice.innerHTML, subDiscount);
    } else {
      aboPrice.innerHTML = customizePrice(aboPrice.innerHTML, subDiscountMax);
    }
  });
  var faqs = document.querySelectorAll('.faq');
  function setAnswersHeight(){
    faqs.forEach(function(faq){
      var questionHeight = faq.querySelector('.question').offsetHeight;
      var answerHeight = faq.querySelector('.answer').offsetHeight;
      faq.setAttribute("style", "--height:" + answerHeight + 'px');
    });
  }
  setAnswersHeight();
  window.addEventListener("resize", () => {
    setAnswersHeight();
  });
}

// Cart scripts
var bodyIsCart = document.body.classList.contains('cart');
if(bodyIsCart){
  document.body.classList.add('index');
  waitForElement('.slidecarthq', 20000).then(function(){
    document.querySelector('.menu-cart').click();
  });
}

// Index scripts
var bodyIsIndex = document.body.classList.contains('index');
if(bodyIsIndex){
  // Hero banner
  document.addEventListener("mousemove", parallax);
  const elem = document.querySelector("#hero-sachets .sachets-wrapper div:last-of-type");
  function parallax(e) {
    let _w = window.innerWidth/2;
    let _mouseX = e.clientX;
    let _depth6 = `${50 + (_mouseX - _w) * 0.01}% 50%`;
    let _depth5 = `${50 + (_mouseX - _w) * 0.02}% 50%`;
    let _depth4 = `${50 + (_mouseX - _w) * 0.04}% 50%`;
    let _depth3 = `${50 + (_mouseX - _w) * 0.04}% 50%`;
    let _depth2 = `${50 + (_mouseX - _w) * 0.05}% 50%`;
    let _depth1 = `${50 + (_mouseX - _w) * 0.05}% 50%`;
    let x = `${_depth6}, ${_depth5}, ${_depth4}, ${_depth3}, ${_depth2}, ${_depth1}`;
    elem.style.backgroundPosition = x;
  };
  let video = document.querySelector("video");
  video.muted = true;
  let playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.then((_) => {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.intersectionRatio !== 1 &&
              !video.paused
            ) {
              video.play();
            } else if (video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(video);
    });
  }
  // Hero sachets aspect-ratio
  var hero = document.getElementById('hero-graphic');
  var heroSachetsSizet = () => {
    var heroHeight = hero.clientHeight;
    var heroWidth = heroHeight * 1074 / 1400;
    hero.style.setProperty('--height', `${heroHeight}px`);
    hero.style.setProperty('--width', `${heroWidth}px`);
  }
  window.addEventListener('resize', heroSachetsSizet);
  heroSachetsSizet();
  // Arrow scroll to
  var element = document.querySelector("#hero-tuto");
  document.querySelector("#hero-banner .icon-arrow").addEventListener("click", function(){
    element.scrollIntoView({ behavior: 'smooth', block: 'start'});
  });
}

// Collection scripts
var bodyIsCollection = document.body.classList.contains('collection');
if(bodyIsCollection){
  // Grid
  var filters = {};
  var comboFilter = getComboFilter(filters);
  var animateOptions = {
    speed: 600,
    minDuration: 500,
    maxDuration: 1000,
    easing: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  }
  var grid = new Isotope('#collection-grid', {
    itemSelector: '.product',
    layoutMode: 'fitRows',
    filter: comboFilter,
    getSortData: {
      default: function( itemElem ) {
        var defaultValue = itemElem.getAttribute('data-defaultsort');
        return parseInt(defaultValue);
      },
      date: function( itemElem ) {
        var dateValue = itemElem.getAttribute('data-date');
        return parseInt(dateValue);
      },
      price: function( itemElem ) {
        var priceValue = itemElem.getAttribute('data-price');
        return parseFloat(priceValue);
      }
    },
    sortBy: 'date',
    sortAscending: {
      date: false,
      default: true,
      price: true
    }
  })
  // function equalizeCardHeight(){
  //   var products = grid.getFilteredItemElements();
  //   var maxCardHeight = 0;
  //   products.forEach(function(product){
  //     product.setAttribute("style", "height: auto");
  //   });
  //   products.forEach(function(product){
  //     var cardHeight = product.clientHeight;
  //     if(cardHeight > maxCardHeight){
  //       maxCardHeight = cardHeight;
  //     }
  //   });
  //   products.forEach(function(product){
  //     product.setAttribute("style", "height:" + maxCardHeight + 'px');
  //   });
  // }
  // grid.on( 'arrangeComplete', equalizeCardHeight );
  // equalizeCardHeight();
  // window.addEventListener("resize", () => {
  //   equalizeCardHeight();
  // });

  // Filters
  document.querySelector('#filters').addEventListener( 'click', function( event ) {
    var filter = event.target;
    if ( filter.nodeName != 'BUTTON' ) {
      return;
    }
    filter.classList.toggle('is-checked');
    var filterValue = filter.getAttribute('data-filter');
    var group = filter.parentNode.getAttribute('data-group');
    var filterGroup = filters[ group ];
    if ( !filterGroup ) {
      filterGroup = filters[ group ] = [];
    }
    if ( filter.classList.contains('is-checked') ) {
      filterGroup.push( filterValue );
    } else {
      var index = filterGroup.indexOf( filterValue );
      filterGroup.splice( index, 1 );
    }
    filterGrid();
  });
  // Sort
  var sortLabel = document.querySelector('#sort-btn');
  document.querySelector('#sortby').addEventListener( 'click', function( event ) {
    var sortBtn = event.target;
    if ( (sortBtn.nodeName != 'BUTTON') || sortBtn.classList.contains('is-checked') ) {
      return;
    }
    var sortingBtns = document.querySelectorAll("button[data-sort-by].is-checked");
    sortingBtns.forEach( el => 
      el.classList.remove("is-checked")
    );
    sortBtn.classList.add('is-checked');
    sortLabel.setAttribute("aria-label", sortBtn.textContent);
    sortLabel.textContent = sortBtn.textContent;
    var sortValue = sortBtn.getAttribute('data-sort-by');
    var filtersOffset = document.querySelector('.collection-wrapper').offsetTop;
    animateScrollTo(filtersOffset, animateOptions).then(hasScrolledToPosition => {
      if (hasScrolledToPosition) {
        grid.arrange({ sortBy: sortValue });
      }
    });
  });
  // Filtering
  function filterGrid(){
    var filtersOffset = document.querySelector('.collection-wrapper').offsetTop ;
    console.log(filtersOffset);
    animateScrollTo(filtersOffset, animateOptions).then(hasScrolledToPosition => {
      if (hasScrolledToPosition) {
        var comboFilter = getComboFilter(filters);
        grid.arrange({ filter: comboFilter });
        // updateFilterCounts();
        var count = grid.getFilteredItemElements().length;
        var emptyMsg = document.querySelector('.noproduct');
        if(count == 0){
          emptyMsg.classList.add('visible');
        } else{
          emptyMsg.classList.remove('visible');
        }
      }
    });
  }
  // Chaining filters
  function getComboFilter( filters ) {
    var i = 0;
    var comboFilters = [];
    var message = [];
    for ( var prop in filters ) {
      message.push( filters[prop].join(' ') );
      var filterGroup = filters[ prop ];
      if ( !filterGroup.length ) {
        continue;
      }
      if ( i === 0 ) {
        comboFilters = filterGroup.slice(0);
      }
      else {
        var filterSelectors = [];
        var groupCombo = comboFilters.slice(0);
        for (var k=0, len3 = filterGroup.length; k < len3; k++) {
          for (var j=0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push( groupCombo[j] + filterGroup[k] );
          }
        }
        comboFilters = filterSelectors;
      }
      i++;
    }
    comboFilters.sort();
    var comboFilter = comboFilters.join(', ');
    return comboFilter;
  }
  // Clear filters
  document.querySelector('#clearfilters').addEventListener( 'click', function( event ) {
    document.querySelector('.noproduct').classList.remove('visible');
    filters = {};
    filterGrid();
    var filteredBtns = document.querySelectorAll("button[data-filter].is-checked");
    filteredBtns.forEach( el => 
      el.classList.remove("is-checked")
    )
    var labelBtns = document.querySelectorAll(".collection-wrapper input:checked");
    labelBtns.forEach( el => 
      el.checked = false
    )
  });
}

// Product scripts
var bodyIsProduct = document.body.classList.contains('product');
if(bodyIsProduct){

  // Cartes cadeaux options
  var isCarteCadeau = document.querySelectorAll('.montants-options').length > 0;
  if(isCarteCadeau){
    document.querySelectorAll('.montants-options label span').forEach(function(el){
      el.innerHTML = el.innerHTML.replace(',00 ', '');
    });
  }

  // Variant selectors
  var productMedias = document.querySelector('.product-medias');
  var variantDropdowns = document.querySelectorAll('.product-infos fieldset');
  variantDropdowns.forEach(function(variantDropdown){
    var variantToggle = variantDropdown.querySelector('input[type="checkbox"]');
    var variantLabel = variantDropdown.querySelector('.dropdown > label');
    var options = variantDropdown.querySelectorAll('input[type="radio"]');
    variantToggle.addEventListener('change', function(){
      if(this.checked){
        variantDropdown.classList.add('is-opened');
      } else{
        variantDropdown.classList.remove('is-opened');
      }
    });
    function updateSelectedVariant(el){
      variantLabel.querySelector('span').innerHTML = el.value;
      variantLabel.setAttribute('data-option', el.getAttribute("data-valuehandleized"));
    };
    options.forEach(function(option){
      if(option.checked){
        updateSelectedVariant(option);
      }
      option.addEventListener('change', function(){
        variantToggle.checked = false;
        variantDropdown.classList.remove('is-opened');
        variantDropdown.classList.add("is-changing");
        if(option.checked){
          setTimeout(function() {
            updateSelectedVariant(option);
            productMedias.setAttribute('data-'+ option.name.toLowerCase() , option.getAttribute('data-valuehandleized'));
          }, 150);
        }
        setTimeout(function() {
          variantDropdown.classList.remove("is-changing");
        }, 500);
      });
    });
  });

  // One-time / Subscription scripts
  var spanPrice = document.querySelector('.product-prices-btn .price-regular');
  if(document.querySelector('.product-form-atelier')){
    spanPrice = document.querySelector('.product-form-atelier .price-regular');
  }
  var spanOldPrice = document.querySelector('.product-prices-btn .price-sale');
  var qtty_btn = document.querySelector('.quantity__input');
  var customSeal = document.querySelector('.subscription-section');
  var customSealToggle = document.getElementById('subscription-toggle');
  var customSealDropdown = customSeal.querySelector('.subscription-options');
  var customSealLabel = customSeal.querySelector('.subscription-options > label');
  var customSealOptions = customSeal.querySelector('#subscription-options-list');
  var customSealDiscount = customSeal.querySelector('.subscription-discount-value');

  // Ateliers
  
  


  // Abonnements
  waitForElement(".sealsubs-target-element", 20000).then(function(){
    mySubscriptionForm();
  });
  function mySubscriptionForm(){
    var seal = document.querySelector('.sealsubs-target-element');
    var sealSelect = seal.querySelector('.sls-select');
    var sealSelectLabel = seal.querySelector('.selling-plan-group-options-name-select > label').innerText;
    var sealOptions = sealSelect.childNodes;
    var sealPlan = seal.querySelector('[data-sls-selling_plan]');
    var sealOnce = seal.querySelector('[data-one-time-option-radio] input');
    var sealSubscribe = seal.querySelector('[data-selling-plan-group-option-radio] input');

    // Create dropdown
    customSealDropdown.setAttribute("style", "--dropdown-total:" + sealOptions.length);
    sealOptions.forEach(function(sealOption, index){
      var defaultOptionValue = sealOption.value;
      var defaultOptionLabel = sealOption.innerText;
      var btn = document.createElement('button');
      btn.setAttribute('data-value', defaultOptionValue);
      btn.innerHTML = '<span>'+ sealSelectLabel + defaultOptionLabel + '</span>';
      if(index == 0){
        btn.classList.add('is-checked');
        customSealLabel.textContent = sealSelectLabel + defaultOptionLabel;
        customSealLabel.ariaLabel = customSealLabel.textContent;
      }
      customSealOptions.appendChild(btn);
    });
    customSealDropdown.classList.add('is-loaded');

    // Synchronize subscription forms
    customSealOptions.childNodes.forEach(function(btn, index){
      btn.addEventListener('click', function(){
        customSealToggle.checked = true;
        // sealSubscribe.click();
        document.getElementById('subscription-options-toggle').checked = false;
        customSealDropdown.classList.add("is-changing");
        setTimeout(function() {
          customSealOptions.querySelector('.is-checked').classList.remove('is-checked');
          btn.classList.add('is-checked');
          var optionValue = btn.getAttribute('data-value');
          customSealLabel.textContent = btn.querySelector('span').innerText;
          customSealLabel.ariaLabel = customSealLabel.textContent;
          sealSelect.value = optionValue;
          customSealToggle.dispatchEvent(new Event('change'));
          sealSelect.dispatchEvent(new Event('change'));
        }, 150);
        setTimeout(function() {
          customSealDiscount.innerText = parseFloat(seal.querySelector('.sls-savings-badge').innerText.replace('REMISE ', '').replace('%', ''));
        }, 200);
        setTimeout(function() {
          customSealDropdown.classList.remove("is-changing");
        }, 500);
      });
    });
    if (window.location.href.indexOf("?selling_plan") > -1) {
      var url = location.href.split('?')[0];
      history.replaceState(null,null,url);
    }
    customSealToggle.addEventListener('change', function(){
      if(this.checked){
        sealSubscribe.click();
        var optionValue = customSealOptions.querySelector('.is-checked').getAttribute('data-value');
        sealPlan.value = optionValue;
      } else{
        sealOnce.click();
        sealPlan.value = '';
      }
      synchronizePrices();
      
    });
    document.querySelector('.sealsubs-target-element').classList.add('sr');
  }
  
  function synchronizePrices(){
    setTimeout(function() {
      var price = document.querySelector('.default-product-prices span[class*="regular"]');
      var priceValue = parseFloat(price.innerHTML.replace(',', '.'));
      if (document.querySelectorAll('.default-product-prices span[class*="sale"]').length > 0){
        var oldPriceValue = parseFloat(document.querySelector('.default-product-prices span[class*="sale"]').innerHTML.replace(',', '.'));
      } else{
        var oldPriceValue = priceValue;
      }
      if(customSealToggle.checked){
        if(document.querySelector('.selling-plan-group-options-name-select > label').innerHTML == 'Pendant&nbsp;'){
          var itemsPerInvoice = parseInt(document.querySelector('.subscription-options > label').innerText.replace(/\D/g,''));
          oldPriceValue = priceValue * itemsPerInvoice;
          var dicountPercent = parseFloat(document.querySelector('.sls-savings-badge').innerText.replace('REMISE ', '').replace('%', ''));
          var discount = Math.ceil((priceValue * dicountPercent / 100) * 100) / 100;
          priceValue = ((priceValue - discount) * itemsPerInvoice);
        } else{
          priceValue = parseFloat(document.querySelector('.sls-selling-plan-group-price .sls-price .money').innerHTML.replace(/[^\d.,-]/g, "").replace(",", ".").replace(/\.(?=.*\.)/g, ""));
        }
        console.log(priceValue);
        spanPrice.textContent = (priceValue * qtty_btn.value).toFixed(2).replace('.', ',') + '€';
        spanOldPrice.textContent = (oldPriceValue * qtty_btn.value).toFixed(2).replace('.', ',') + '€';
      } else{
        // Sale
        if (document.querySelectorAll('.default-product-prices span[class*="sale"]').length > 0){
          oldPriceValue = parseFloat(document.querySelector('.default-product-prices span[class*="sale"]').innerHTML.replace(',', '.'));
          spanOldPrice.textContent = (oldPriceValue * qtty_btn.value).toFixed(2).replace('.', ',') + '€';
        } else{
          spanOldPrice.textContent = '';
        }
        spanPrice.textContent = (priceValue * qtty_btn.value).toFixed(2).replace('.', ',') + '€';
      }
    }, 200);
  }
  synchronizePrices();
  document.querySelector('.quantity__input').addEventListener("change", function(){
    synchronizePrices();
  });
  let priceObserver = new MutationObserver(mutationRecords => {
    synchronizePrices();
  });
  priceObserver.observe(document.querySelector('.default-product-prices'), {
    childList: true
  });
}


// Blog scripts
var bodyIsBlog = document.body.classList.contains('blog');
if(bodyIsBlog){
  var animateOptions = {
    speed: 600,
    minDuration: 500,
    maxDuration: 1000,
    easing: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
  }
  var blog = new Isotope( '#articles', {
    itemSelector: '.article',
    layoutMode: 'vertical'
  });
  var filters = [];
  var filtersElem = document.querySelector('.filters');
  filtersElem.addEventListener( 'click', function( event ) {
    var target = event.target;
    if ( target.nodeName != 'BUTTON' ) {
      return;
    }
    target.classList.toggle('is-checked');
    var isChecked = target.classList.contains('is-checked');
    var filter = target.getAttribute('data-filter');
    if ( isChecked ) {
      addFilter( filter );
    } else {
      removeFilter( filter );
    }
    var filtersOffset = document.querySelector('.blog-content').offsetTop;
    animateScrollTo(filtersOffset, animateOptions).then(hasScrolledToPosition => {
      if (hasScrolledToPosition) {
        blog.arrange({ filter: filters.join(',') });
      }
    });
  });
  function addFilter( filter ) {
    if ( filters.indexOf( filter ) == -1 ) {
      filters.push( filter );
    }
  }
  function removeFilter( filter ) {
    var index = filters.indexOf( filter);
    if ( index != -1 ) {
      filters.splice( index, 1 );
    }
  }
}

// Blog scripts
var bodyIsArticle = document.body.classList.contains('article');
if(bodyIsArticle){
  articleIframes = document.querySelectorAll('.page-text iframe');
  if(articleIframes.length > 0){
    articleIframes.forEach(function(iframe){
      var wrapper = document.createElement('div');
      wrapper.classList.add('iframe-wrapper');
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    });
  }
}

// Login scripts
var bodyIsLogin = document.body.classList.contains('login');
if(bodyIsLogin){
  if (window.location.href.indexOf("checkout") > -1) {
    var url = location.href.replace("#register", "") + "#register";
    history.replaceState(null,null,url);
  }
}

// Order scripts
var bodyIsOrder = document.body.classList.contains('order');
if(bodyIsOrder){
  // var items = document.querySelectorAll('.order-items li');
  // items.forEach(function(item){
  //   if (item.querySelectorAll('[data-value*="coffret"]').length > 0){
  //     var subinterval = item.querySelector('[data-value*="coffret"] span');
  //     subinterval.innerHTML = subinterval.innerText.replace(/\D/g,'');
  //   }
  //   if (item.querySelectorAll('[data-value*="jours"]').length > 0){
  //     var subinterval = item.querySelector('[data-value*="jours"] span');
  //     subinterval.innerHTML = subinterval.innerText.replace(/\D/g,'');
  //   }
  // });
}

// Subscriptions scripts
waitForElement('.seal-subscription-page', 20000).then(function(){
  var subscriptionContent;
  var subscription = document.querySelector('.seal-subscription-page');
  function createLayout(container, contentType, className){
    var subscriptionHeader = document.createElement('header');
    subscriptionHeader.classList.add('page-header', 'account-header');
    subscriptionHeader.innerHTML = `
      <h1 class="page-title">Mon compte</h1>
    `;
    container.parentNode.prepend(subscriptionHeader);
    var subscriptionWrapper = document.createElement('div');
    subscriptionWrapper.classList.add('content-wrapper', 'account-wrapper', contentType);
    subscriptionWrapper.innerHTML = `
    <div class="content-full">
      <nav class="account-nav">
        <a href="/account"><span>Commandes</span></a>
        <a class="${className}" href="https://lesbruleriesdequartier.com/a/subscriptions"><span>Abonnements</span></a>
        <a href="/account/addresses"><span>Adresses</span></a>
        <a href="/account/logout"><span>Déconnexion</span></a>
      </nav>
      <div class="account-content"></div>
    </div>
    `;
    container.parentNode.append(subscriptionWrapper);
    subscriptionContent = document.querySelector('.account-content');
    subscriptionContent.append(container);
  }
  // Check if logged in
  var subscriptionList = document.querySelectorAll('.seal-subscriptions-list');
  var subscriptionBtns = document.querySelectorAll('.seal-edit-buttons-wrapper');
  if(subscriptionList.length > 0){
    // List
    createLayout(subscription.parentNode, 'subscription-list', 'active');
    waitForElement('.seal-container', 20000).then(function(){
      var subItemsList = subscriptionList[0];
      if (subItemsList.querySelectorAll('a').length > 0){
        subItemsList.childNodes.forEach(function(subItem){
          var subURL = subItem.querySelector('.seal-layout > div:nth-of-type(1) a').href;
          var subNum = subItem.querySelector('.seal-layout > div:nth-of-type(1) a').innerText;
          var subInterval = subItem.querySelector('.seal-layout > div:nth-of-type(1) > div:last-of-type').innerText;
          if (subInterval.includes('mois')){
            subInterval = 'Coffrets mensuels';
          }
          var [DD, MM, YYYY] = subItem.querySelector('.seal-subdued [data-convert-time]').innerText.slice(0, -6).split('/');
          var subDate = new Date(+YYYY, MM - 1, +DD).toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
          var subStatus = subItem.querySelector('.seal-layout > div:nth-of-type(2) > div:last-of-type span').innerText;
          var subPrice = subItem.querySelector('[data-seal-format-money]').innerHTML.replace('&nbsp;', '');
          var subItemCustom = document.createElement('a');
          subItemCustom.href = subURL;
          subItemCustom.classList.add('order-block');
          subItemCustom.innerHTML = `
          <p class="order-date"><span>${subDate}</span></p>
          <div class="order-infos">
            <h2 class="order-name">Abonnement ${subNum}</h2>
            <div class="order-tags">
              <div data-status="${subStatus}" class="tag-status">${subStatus}</div>
            </div>
          </div>
          <div class="order-price">
            <div>${subPrice}</div>
            <div class="subscription-interval"><span>${subInterval}</span></div>
          </div>
          `;
          subscriptionContent.append(subItemCustom);
        });
      } else{
        var subItemEmpty = document.createElement('div');
        subItemEmpty.classList.add('order-block-empty');
        subItemEmpty.innerHTML = `
        <p>Vous n’avez pas encore souscrit d’abonnement.</p>
        <a class="btn-800-m" href="/pages/abonnements">Découvrez nos formules</a>
        `;
        subscriptionContent.append(subItemEmpty);
      }
    });
  }
  else if(subscriptionBtns.length > 0){
    // Detail
    createLayout(subscription, 'subscription-detail', '');
    waitForElement('.seal-container', 20000).then(function(){
      setTimeout(function() {
        // Create layout
        var subNum = subscription.querySelector('.seal-twoThirds > div:nth-child(2) .seal-subdued').innerText;
        var subStatus = subscription.querySelector('span[class*="-status-label"]').innerText;
        var [DD, MM, YYYY] = subscription.querySelector('.seal-twoThirds [data-seal-t*="created_at_label"] + span').innerText.slice(0, -6).split('/');
        var subDate = new Date(+YYYY, MM - 1, +DD).toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
        var subShipping = subscription.querySelectorAll('.seal-customer-portal-shipping-card > div:first-of-type div');
        var subBlock = document.createElement('div');
        subBlock.classList.add('order-block', 'subitem-block');
        subBlock.innerHTML = `
          <p class="order-date"><span>${subDate}</span></p>
          <div class="order-infos">
            <h2 class="order-name">Abonnement ${subNum}</h2>
            <div class="order-tags">
              <div data-status="${subStatus}" class="tag-status">${subStatus}</div>
            </div>
          </div>
          <div class="order-price">
            <div></div>
          </div>
          <div class="order-texts">
            <div class="order-shipping">
              <h2>Adresse d’expédition</h2>
              <p></p>
            </div>
          </div>
          <div class="order-items"></div>
          <div class="order-upcoming"></div>
        </div>
        `;
        // Clone addresses
        subscriptionContent.prepend(subBlock);
        var subShippingContainer = document.querySelector('.order-shipping p');
        if(subShipping.length > 0){
          subShipping.forEach(function(subShippingLine){
            subShippingContainer.append(subShippingLine.innerText);
            var br = document.createElement("br");
            subShippingContainer.append(br);
          });
        } else{
          subShippingContainer.innerHTML = `
          Livraison par coursier<br/>
          Vous recevrez un SMS pour convenir d’un RDV lorsque votre commande sera prête.
          `;
        }
        
        // Move payment option
        if (subscription.querySelectorAll('[data-seal-t="overview_payment_method_title"]').length > 0){
          var subPayment = subscription.querySelector('[data-seal-t="overview_payment_method_title"]').closest('div.seal-container');
          subPayment.classList.add('order-payment');
          document.querySelector('.order-texts').append(subPayment);
        }
        // Move edit interval
        var subEditInterval = subscription.querySelector('.seal-layout > div.seal-twoThirds > div:nth-child(2) > div[data-editable-container]');
        var subActions = subscription.querySelectorAll('.seal-dynamic-sectioned > div');
        var orderTagsContainer = document.querySelector('.order-tags');
        var orderPriceContainer = document.querySelector('.order-price');
        subActions.forEach(function(subAction){
          orderTagsContainer.append(subAction);
        });
        orderPriceContainer.append(subEditInterval);
        // Move products
        var subItemsContainer = document.querySelector('.order-items');
        subItemsContainer.append(document.querySelector('#seal-subscription-items-list-container'));
        // Update product layout and total price
        var subItems = document.querySelectorAll('#seal-subscription-items-list > div');
        var subTotalPrice = 0;
        subItems.forEach(function(product){
          var productName = product.querySelector('span[class*="-name"]');
          if (productName.innerText.includes(' - ')){
            var productNameArr = productName.innerText.split(' - ');
            productName.innerText = productNameArr[0];
            var productVariantTitle = document.createElement("span");
            productVariantTitle.classList.add('producttitle-variant');
            productVariantTitle.innerText = productNameArr[1];
            productName.append(productVariantTitle);
          }
          var subPrice = product.querySelector('.seal-oneThird > div > span[data-seal-format-money]');
          var subPriceValue = parseFloat(subPrice.getAttribute('data-value'));
          subPrice.innerText = subPrice.innerHTML.replace('&nbsp;', '');
          subTotalPrice += subPriceValue;
          // var onetime = false;
          // if(product.querySelectorAll('.seal-one-time-purchase-label').length > 0){
          //   product.classList.add('one-time');
          //   onetime = true;
          // }
          // if (!onetime){
          //   var subRegularPrice = product.querySelector('.seal-line-through');
          //   subRegularPrice.innerText = subRegularPrice.innerHTML.replace('&nbsp;', '');
          // }
          // var subFinalPrice = product.querySelector('.seal-oneThird > div > span[data-seal-format-money]');
          // var subFinalPriceValue = parseFloat(subFinalPrice.getAttribute('data-value'));
          // subFinalPrice.innerText = subFinalPrice.innerHTML.replace('&nbsp;', '');
          // subTotalPrice += subFinalPriceValue;
        });
        var orderPrice = document.querySelector('.order-price div');
        orderPrice.innerText = parseFloat(subTotalPrice).toFixed(2).toString().replace('.', ',')+'€';

        // Calendar
        if(subscription.querySelectorAll('[data-seal-t*="_schedule_title"]').length > 0){
          var orderUpcomingContent = subscription.querySelector('[data-seal-t*="_schedule_title"]').closest('div.seal-container');
          var orderUpcoming = document.querySelector('.order-upcoming');
          orderUpcoming.append(orderUpcomingContent);
          var orderUpcomingLine = orderUpcoming.querySelectorAll('li');
          // Traitement
          if(orderUpcoming.querySelector('h3').innerText.includes('traitement')){
            if(document.querySelectorAll('[data-seal-t="overview_billing_interval_label"]').length > 0){
              var subInterval = document.querySelector('.order-price [data-seal-t="overview_billing_interval_label"]').nextElementSibling.innerText.replace(/\D/g,'');
              var subIntervalLabel = document.createElement('div');
              subIntervalLabel.classList.add('subscription-interval-label');
              subIntervalLabel.innerHTML = `
              <span>${subInterval} mois de coffrets</span>
              `;
              orderPrice.append(subIntervalLabel);
              document.querySelector('.order-price [data-editable-container]').classList.add('sr');
            }
            orderUpcomingLine.forEach(function(upcoming){
              var upcomingContent = document.createElement("div");
              upcomingContent.classList.add('upcoming-content');
              upcomingContent.innerHTML = `
                <div class="upcoming-date"></div>
                <div class="upcoming-btn"></div>
              `;
              upcoming.append(upcomingContent);
              var [DD, MM, YYYY] = upcoming.querySelector('.seal-twoThirds [data-convert-time]').innerText.slice(0, -6).split('/');
              var upcomingDate = new Date(+YYYY, MM - 1, +DD).toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
              upcoming.querySelector('.upcoming-date').append(upcomingDate);
              if (upcoming.querySelectorAll('.seal-edit-button').length > 0){
                upcoming.querySelector('.upcoming-btn').append(upcoming.querySelector('.seal-edit-button'));
              } else {
                var upcomingBtn = document.createElement("div");
                var upcomingStatus = upcoming.querySelector('[data-seal-t*="overview_"]').getAttribute('data-seal-t').replace('overview_fulfillment_schedule_', '').replace('_text', '').replace('_', '-');
                upcomingBtn.classList.add('tag-'+upcomingStatus);
                upcomingBtn.innerText = upcoming.querySelector('[data-seal-t*="overview_"]').innerText.replace('(', '').replace(')', '');
                upcoming.querySelector('.upcoming-btn').append(upcomingBtn);
              }
            });
          } else if (orderUpcoming.querySelector('h3').innerText.includes('facturation')){
              // Facturation
              if(document.querySelectorAll('[data-seal-t="overview_required_number_of_payments_label"]').length > 0){
                document.querySelector('[data-seal-t="overview_required_number_of_payments_label"]').closest('div').classList.add('sr');
              }

              orderUpcomingLine.forEach(function(upcoming){
              var upcomingContent = document.createElement("div");
              upcomingContent.classList.add('upcoming-content');
              upcomingContent.innerHTML = `
                <div class="upcoming-date"></div>
                <div class="upcoming-btn"></div>
              `;
              upcoming.append(upcomingContent);
              var [DD, MM, YYYY] = upcoming.querySelector('.seal-oneHalf:first-of-type [data-convert-time]').innerText.slice(0, -6).split('/');
              var upcomingDate = new Date(+YYYY, MM - 1, +DD).toLocaleString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
              upcoming.querySelector('.upcoming-date').append(upcomingDate);
              if (upcoming.querySelectorAll('[data-seal-t="overview_reschedule_button"]').length > 0){
                upcoming.querySelector('.upcoming-btn').append(upcoming.querySelector('[data-seal-t="overview_reschedule_button"]').closest('.seal-edit-button'));
              } else {
                var upcomingBtn = document.createElement("div");
                var upcomingStatus = upcoming.querySelector('[data-seal-t*="overview_"]').getAttribute('data-seal-t').replace('overview_billing_schedule_', '').replace('_text', '').replace('_', '-');
                upcomingBtn.classList.add('tag-'+upcomingStatus);
                upcomingBtn.innerText = upcoming.querySelector('[data-seal-t*="overview_"]').innerText.replace('(', '').replace(')', '');
                upcoming.querySelector('.upcoming-btn').append(upcomingBtn);
              }
            });
          }
        }
      }, 100);
    });
  } else {
    // Logged off
    createLayout(subscription, 'subscription-detail', 'logged-off');
    waitForElement('.seal-layout', 20000).then(function(){
      var subscriptionLog = document.querySelectorAll('div[data-seal-t="list_not_logged_in_text"]');
      if(subscriptionLog.length > 0){
        var subscriptionLogMsg = document.createElement('div');
        subscriptionLogMsg.classList.add('order-block-empty');
        subscriptionLogMsg.innerHTML = `
        <p></p>
        <a class="btn-800-m" href="/account/login">Se connecter</a>
      `;
        subscriptionLogMsg.querySelector('p').append(document.querySelector('div[data-seal-t="list_not_logged_in_text"]').innerText);
        subscriptionContent.prepend(subscriptionLogMsg);
      }
    });
  }
}).catch(()=>{
  // console.log('Subscription not loaded');
});